// Root module
export const signIn = "signIn"
export const fetchStatistics = "fetchStatistics"
export const restartService = "restartService"

// Company module
export const fetchCompanyList = "fetchCompanyList"

// Country module
export const fetchCountryList = "fetchCountryList"

// Market module
export const fetchMarketList = "fetchMarketList"
export const addNewMarket = "addNewMarket"

// Venue module
export const fetchVenueList = "fetchVenueList"
export const addNewVenue = "addNewVenue"
export const deleteVenue = "deleteVenue"
export const updateVenue = "updatesVenue"

// Version module
export const fetchGatewayVersionList = "fetchGatewayVersionList"
export const fetchSblDriveVersionList = "fetchSblDriveVersionList"

// SmartBox module
export const fetchSmartBoxList = "fetchSmartBoxList"
export const fuzzySearchSmartBoxList = "fuzzySearchSmartBoxList"
export const addNewSmartBox = "addNewSmartBox"
export const updateSmartBoxes = "updateSmartBoxes"
export const deleteSmartBoxes = "deleteSmartBoxes"
export const fetchOperationLogList = "fetchOperationLogList"
export const extractOperationLogsAsCsv = "extractOperationLogsAsCsv"
export const deleteSmartBox = "deleteSmartBox"
export const updateSmartBox = "updateSmartBox"
export const updateSmartBoxesLastSeenAt = "updateSmartBoxesLastSeenAt"
export const updateSmartBoxesSbldriveVersions =
    "updateSmartBoxesSbldriveVersions"
export const openTunnel = "openTunnel"
export const closeTunnel = "closeTunnel"
